import { render, staticRenderFns } from "./download-widget.vue?vue&type=template&id=4c83c528"
import script from "./download-widget.vue?vue&type=script&lang=js"
export * from "./download-widget.vue?vue&type=script&lang=js"
import style0 from "./download-widget.vue?vue&type=style&index=0&id=4c83c528&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports